import { Box, styled } from '@mui/material';

export const ContainerStyled = styled(Box)(({ theme }) => ({
  marginTop: '16px',
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const ContainerLeft = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('xxl')]: {
    marginRight: '12px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    marginRight: '8px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginRight: '4px',
  },
  [theme.breakpoints.down('sm')]: {
    marginRight: '8px',
  },
}));

export const ContainerRight = styled(Box)(({ theme }) => ({
  width: '100%',
  [theme.breakpoints.up('xxl')]: {
    marginLeft: '12px',
  },
  [theme.breakpoints.between('lg', 'xxl')]: {
    marginLeft: '8px',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    marginLeft: '4px',
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: 0,
    marginTop: 12,
  },
}));
